import React, { createRef } from 'react';
import Manifest from './Manifest';
import http from 'utils/http';
import { connect } from 'react-redux';
import cookies from 'utils/cookies';
import { setDeleteAction } from 'store/actions/deleteAction';
import FfmModal from './FfmModal';

class ManifestContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: null,
      modal_data: {},
      ffm: {},
      data: [],
      productsList: [],
      uld_remarks: [],
      awb_value: null,
      product: 'ALL',
      nil: false,
      doc: false,
      edit: true,
      anchorEl: null,
      message_logs: [],
      msg_id: null,
      no_scan_awbs: [],
      is_empty: false,
      add_uld: false,
      uldFields: {},
      add_awb: false,
      awbFields: {},
      columnWidth: {},
      fullscreen: false,
      open: false,
      filter: {},
      filteredManifestData: [],
      disableFlightFields: false,
      isNoOp: false,
      dis_alert: false,
      can_edit: false,
      type: null
    };
    this.rowRefs = {};
    this.anchorRef = createRef();
    this.columnRef = {
      awb_no: [],
      org_dest: [],
      pcs: [],
      wgt: [],
      remarks: [],
      spl_code: [],
      products: [],
      actions: [],
    };
    this.fileInputRef = createRef();
  }

  componentDidMount() {
    //UPDATE COLUMN WIDTH
    this.updateColumnWidth();

    if (this.props.ffm && this.props.ffm?.id) {
      this.setState({
        ffm: this.props.ffm,
        is_empty: false
      }, () => {
        this.fetchProducts();
        this.filterData();
        // this.getConfig();
      });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.data !== prevState.data) {
      this.updateColumnWidth();
    }

    if (prevProps.ffm != this.props.ffm) {
      console.log('ffm changed in Manifest Container', this.props.ffm);
      this.setState({
        ffm: this.props.ffm,
        is_empty: false
      }, () => {
        if (this.state.productsList.length == 0) {
          this.fetchProducts();
        }
        this.filterData();
      });
    }
    if (this.state.disableFlightFields !== this.props.disableFlightFields) {
      this.setState({ disableFlightFields: this.props.disableFlightFields });
    }
    if (this.state.isNoOp !== this.props.isNoOp) {
      this.setState({ isNoOp: this.props.isNoOp });
    }
  }

  getConfig = () => {
    http.get('/settings?key=ffm_edit').then(({ data }) => {
      if (data.data.length > 0) {
        let edit = false;
        if (data.data[0].value && data.data[0].value.data === 'true') {
          edit = true;
        }
        this.setState({ edit });
      }
    });
  };


  acceptFfm = () => {
    const stn = cookies.get('station_code');
    http.put(`/flight/verify/${this.state.ffm.id}`, { type: this.state.ffm.org == stn ? 'out' : 'in' }).then(() => {
      this.setState({ modal: null });
    });
  };

  fetchProducts = () => {
    if (this.props.ffm?.airlineId)
      http.get(`/products?airlineId=${this.props.ffm?.airlineId}&common=${true}`).then(({ data }) => {
        this.setState({ productsList: data.data });
      });
  };

  handleHistory = (e) => {
    this.setState({ anchorEl: e.currentTarget });
  };

  handleClose = () => {
    this.setState({ anchorEl: null });
  };

  onRefresh = () => {
    http.get(`/manifest/map/${this.props.ffm.id}`);
  };


  handleOpen = (modal, modal_data = {}) => {
    this.setState({
      modal,
      modal_data
    });
  };

  onClose = () => {
    this.setState({
      modal: false,
      modal_data: {}
    });
  };
  checkHandledAs = (e, uldid, awbid) => {
    const refNode = this.rowRefs[uldid];
    console.log('checkHandledAs called');
    let stn = cookies.get('station_code');
    let flight_type = this.props.ffm.org == stn ? 'origin' : 'destination';
    console.log('flight_type', flight_type);
    console.log('this.props.ffm.org', this.props.ffm.org);
    console.log('stn', stn);
    let intact = true;
    if (e.target.value === 'Intact') {
      console.log('Intact selected');
      if (flight_type === 'origin') {
        console.log('Origin flight');
        let uld = this.props.ffm.flight_uld?.find(uld => uld.id == uldid);
        if (!uld.is_bulk) {
          uld.flight_awbs?.map((awb) => {
            console.log('awb.spl_code', awb.spl_code);
            if (!awb.spl_code || (awb.spl_code && !awb.spl_code.includes('BUP') && !awb.spl_code.includes('SLU'))) {
              intact = false;
              console.log('intact set to false');
            }
          });
        }
      } else {
        console.log('Destination flight');
        let uld = this.props.ffm.flight_uld?.find(uld => uld.id == uldid);
        if (!uld.is_bulk) {
          console.log('uld.flight_awbs', uld.flight_awbs);
          uld.flight_awbs?.map((awb) => {
            if (!awb.spl_code || (awb.spl_code && !awb.spl_code.includes('BUP') && !awb.spl_code.includes('SLU'))) {
              intact = false;
              console.log('intact set to false');
            }
          });
          if (!intact) {
            // if (dest_stn.code == flight.dest) {
            intact = true;
            let dest = false;
            uld.flight_awbs?.map((awb) => {
              if (awb.dest != this.props.ffm.dest) {
                if (dest && dest != awb.dest) {
                  intact = false;
                  console.log('intact set to false');
                } else {
                  dest = awb.dest;
                }
              } else {
                intact = false;
                console.log('intact set to false');
              }
            });
            // }
          }
        }
      }
      console.log('intact', intact);
      //if intact is false, open popup to confirm else call onChange
      if (!intact) {
        this.handleOpen('intact', {
          uldid,
          awbid,
          value: e.target.value,
          anchorEl: refNode,
          onConfirm: () => this.onChange(e, uldid, awbid) // Pass onConfirm callback
        });
        this.props.setDelete({
          modal: true,
          id: uldid,
          confirmMessage: 'You are overriding the system determined value of \'Loose\'.',
          confirmBtn: 'Confirm',
          closeBtn: 'Cancel',
          warning: true,
          anchorEl: refNode,
          onConfirm: () => this.onChange(e, uldid, awbid)
        });
      } else {
        this.onChange(e, uldid, awbid);
      }

    } else {
      this.onChange(e, uldid, awbid);
    }
  };

  onChange = (e, uldid, awbid) => {
    let value = e.target ? e.target.value : e;
    const name = e.target.name;
    if (name === 'productsId') {
      http.put(`/manifest/awb/${awbid}`, { productsId: value });
    } else if (name === 'uld_type') {
      http.put(`/manifest/uld/${uldid}`, { uld_type: value });
    } else if (name === 'segment') {
      http.put(`/manifest/uld/${uldid}`, { segment: value });
    } else if (name === 'type') {
      let obj = { type: value };
      // if (value === 'Loose') {
      //   obj = {
      //     type: value,
      //     uld_type: null,
      //     segment: null,
      //   };
      // }
      http.put(`/manifest/uld/${uldid}`, obj);
      this.props.setDelete({
        modal: false,
        id: false,
        anchorEl: false,
        onConfirm: () => { },
      });
    } else if (name === 'remarks') {
      let uld_remarks = [...this.state.uld_remarks];
      uld_remarks[uldid] = value;
      this.setState({ uld_remarks });
    } else if (name === 'sub_remark') {
      let uld_remarks = [...this.state.uld_remarks];
      http.put(`/manifest/uld/${uldid}`, { remark: uld_remarks[uldid] || null });
    } else if (name == 'awb') {
      this.setState({ awb_value: value });
    } else if (name == 'sub_awb') {
      http.put(`/manifest/awb/${awbid}`, { awbId: this.state.awb_value || null });
    } else if (name == 'org') {
      if (uldid != value)
        http.put(`/manifest/awb/${awbid}`, { org: value?.toUpperCase() });
    } else if (name == 'dest') {
      if (uldid != value)
        http.put(`/manifest/awb/${awbid}`, { dest: value?.toUpperCase() });
    } else if (name == 'pcs') {
      if (uldid != value)
        http.put(`/manifest/awb/${awbid}`, { pcs: value });
    } else if (name == 'wgt') {
      if (uldid != value)
        http.put(`/manifest/awb/${awbid}`, { wgt: value });
    } else if (name == 'spl_code') {
      if (uldid != value)
        http.put(`/manifest/awb/${awbid}`, { spl_code: value?.toUpperCase() });
    } else if (name == 'awb_no') {
      if (uldid != value)
        http.put(`/manifest/awb/${awbid}`, { awb_no: value?.toUpperCase() });
    } else if (name == 'awb_remark') {
      if (uldid != value)
        http.put(`/manifest/awb/${awbid}`, { remark: value });
    }

  };


  handleFilter = (value) => {
    this.setState({
      product: value,
      is_empty: false
    }, () => {
      this.filterData();
    }
    );
  };

  filterData = () => {
    const stn = cookies.get('station_code');
    let filteredData = [];
    this.state.ffm && this.state.ffm?.flight_uld?.map(uld => {
      let filter_awb = [];
      uld.flight_awbs?.filter(awb => {
        if (awb.product?.name == this.state.product || this.state.product == 'ALL') {
          filter_awb.push(awb);
        }
      });
      // if (filter_awb.length > 0) {
      let uld_data = { ...uld };
      uld_data.flight_awbs = filter_awb;
      filteredData.push(uld_data);
      // }
    });
    //map through filtered and check if  awb's org, dest, pcs, wgt is null then set is_empty to true
    filteredData.map(uld => {
      uld.flight_awbs.map(awb => {
        if (!awb.org || !awb.dest || !awb.pcs || !awb.wgt) {
          this.setState({ is_empty: true });
        }
      });
    });
    let doc = this.state.ffm?.org == stn ? this.state.ffm?.out_ffm : this.state.ffm?.in_ffm;
    this.setState({
      data: filteredData,
      filteredManifestData: filteredData,
      doc: doc,
      message_logs: this.state.ffm?.message_logs || [],
      msg_id: this.state.ffm?.msg_id ? this.state.ffm?.msg_id : doc?.ffmId || this.state.ffm?.docs?.id || null,
      nil: this.state.ffm?.org == stn ? this.state.ffm?.out_nil_ffm : this.state.ffm?.in_nil_ffm
    }, () => {
      this.awbCount();
    });
  };

  checkNoti = (type) => {
    if (!this.state.can_edit) {
      if (this.state.ffm.is_notified) {
        this.setState({
          dis_alert: true,
          can_edit: false,
          type: type
        });
        document.activeElement.blur(); // Remove focus from the input element
      }
    }
  };

  onCloseAlert = () => {
    this.setState({ dis_alert: false });
  };

  onShowAlert = () => {
    this.setState({ dis_alert: true });
  };

  handleConfirm = () => {
    this.setState({
      can_edit: true,
      dis_alert: false
    }, () => {
      if (this.state.type === 'upload' && this.fileInputRef.current) {
        this.fileInputRef.current.click();
      }
    });
  };

  awbCount = () => {
    let awb_no = [];
    this.state.data.map(uld => {
      uld.flight_awbs.map(awb => {
        if (!awb.awbId) {
          if (awb_no && !awb_no.includes(awb.awb_no)) {
            awb_no.push(awb.awb_no);
          }
        }
      });
    });
    this.setState({ no_scan_awbs: awb_no });
  };

  onChangeNil = (e) => {
    const checked = e.target.checked;
    http.put(`/flight/nil/${this.state.ffm.id}`, { nil: checked }).then(() => {
      this.setState({ nil: checked });
    });
  };

  onChangeUld = (e) => {
    let uldFields = { ...this.state.uldFields };
    uldFields[e.target.name] = e.target.value;
    if (e.target.name == 'uld_no') {
      uldFields.uld_no = e.target.value.toUpperCase();
    }
    if (e.target.name == 'c_type') {
      uldFields.uld_no = '';
    }
    // if (e.target.name == 'type' && e.target.value == 'Loose') {
    //   uldFields.uld_type = '';
    //   uldFields.segment = '';
    // }
    this.setState({ uldFields });
  };

  handleUld = (v) => {
    let uld_fields = {
      c_type: 'ULD',
      uld_no: '',
      type: 'Loose',
      uld_type: '',
      segment: '',
      remarks: ''
    };
    this.setState({
      add_uld: v,
      uldFields: uld_fields
    });
  };

  onAddUld = () => {
    const { uld_no, c_type, type, uld_type, segment, remark } = this.state.uldFields;
    http.post(`/manifest/uld/${this.state.ffm.id}`, {
      c_type,
      uld_no,
      type,
      uld_type,
      segment,
      remark
    }).then(() => {
      this.setState({
        add_uld: false,
        uldFields: {}
      });
    });
  };

  deleteUld = async (id) => {
    await http.delete(`/manifest/uld/${id}`).then(({ data }) => {
      if (data.status == 'success') {
        this.props.setDelete({
          modal: false,
          id: false,
          anchorEl: false,
          onConfirm: () => { },
        });
      }
    });
  };

  deleteAwb = async (id) => {
    await http.delete(`/manifest/awb/${id}`).then(({ data }) => {
      if (data.status == 'success') {
        this.props.setDelete({
          modal: false,
          id: false,
          anchorEl: false,
          onConfirm: () => { },
        });
      }
    });
  };

  handleDeleteUld = (id, anchorEl) => {
    this.props.setDelete({
      modal: true,
      id,
      anchorEl,
      onConfirm: () => this.deleteUld(id),
    });
  };

  handleDeleteAwb = (id, anchorEl) => {
    this.props.setDelete({
      modal: true,
      id,
      anchorEl,
      onConfirm: () => this.deleteAwb(id),
    });
  };


  onChangeAwb = (e) => {
    let awbFields = { ...this.state.awbFields };
    awbFields[e.target.name] = e.target.value;
    if (e.target.name == 'awb_no') {
      let value = e.target.value.replace(/\D/g, '');
      if (value.length > 3) {
        value = `${value.slice(0, 3)}-${value.slice(3)}`;
      }
      awbFields.awb_no = value;
    }
    this.setState({ awbFields });
  };

  handleAwb = (v) => {
    let awb_fields = {
      awb_no: '',
      org: '',
      dest: '',
      pcs: '',
      wgt: '',
      spl_code: '',
      productsId: 0
    };
    this.setState({
      add_awb: v,
      awbFields: awb_fields
    });
  };

  onAddAwb = () => {
    const { awb_no, org, dest, pcs, wgt, spl_code, remark, productsId } = this.state.awbFields;
    http.post(`/manifest/awb/${this.state.ffm.id}`, {
      flight_uldId: this.state.add_awb,
      flight_dest: this.state.ffm.dest,
      awb_no,
      org,
      dest,
      pcs,
      wgt,
      spl_code,
      remark,
      productsId: productsId || []
    }).then(() => {
      this.setState({
        add_awb: false,
        awbFields: {}
      });
    });
  };


  updateColumnWidth = () => {
    let columnWidth = {};
    for (let key in this.columnRef) {
      let maxWidth = 0;
      this.columnRef[key].forEach(ref => {
        if (ref) {
          const width = ref.offsetWidth;
          if (width > maxWidth) {
            maxWidth = width;
          }
        }
      });
      columnWidth[key] = maxWidth;
    }
    if (JSON.stringify(this.state.columnWidth) !== JSON.stringify(columnWidth)) {
      this.setState({ columnWidth });
    }
  };

  handleFullScreenToggle = () => {
    this.setState(prevState => ({ fullscreen: !prevState.fullscreen }));
  };

  handleToggle = () => {
    this.setState((prev) => ({ open: !prev.open }));
    // this.setState((prev) => ({ open: prev.open === type ? false : type }));
  };

  filterManifestData = () => {
    const { data, filter } = this.state;
    let filteredData = [...data];
    if (filter.handled_as && filter.handled_as != '') {
      if (filter.handled_as != 'All') {
        filteredData = filteredData.filter((item) => item.type == filter.handled_as);
      }
      else {
        filteredData = filteredData.filter((item) => item);
      }
    }
    if (this.state.filter.search && this.state.filter.search) {
      const search = this.state.filter.search.toLowerCase();
      filteredData = filteredData.map((item) => {
        // Check if ULD number matches
        const uldNoMatch = item.uld_no?.toLowerCase().includes(search);
        // Check if any AWB matches
        const matchedAwbs = item?.flight_awbs?.filter(awb => {
          const awbNoMatch = awb?.awb_no?.toLowerCase().includes(search);
          const splCodeMatch = awb?.spl_code && awb.spl_code.split(',').map(code => code.trim().toLowerCase()).includes(search);
          return awbNoMatch || splCodeMatch;
        }) || [];
        // If ULD number matches, include all AWBs
        if (uldNoMatch) {
          return {
            ...item,
            flight_awbs: item.flight_awbs
          };
        }
        // Only include ULDs with matching AWBs
        if (matchedAwbs.length > 0) {
          return {
            ...item,
            flight_awbs: matchedAwbs
          };
        }
        return null;
      }).filter(item => item !== null);
    }
    this.setState({ filteredManifestData: filteredData, });
  };

  onChangeFilter = (e) => {
    this.setState({
      filter: {
        ...this.state.filter,
        [e.target.name]: e.target.value
      }
    }, () => this.filterManifestData());
  };

  clearSearch = () => {
    this.setState({
      filter: {
        ...this.state.filter,
        search: ''
      }
    }, () => this.filterManifestData());
  };

  render() {
    return (
      <>
        <FfmModal ffm={this.state.ffm} modal={this.state.modal} acceptFfm={this.acceptFfm} />
        <Manifest
          edit={this.state.edit}
          doc={this.state.doc}
          msg_id={this.state.msg_id}
          checkNoti={this.checkNoti}
          dis_alert={this.state.dis_alert}
          onCloseAlert={this.onCloseAlert}
          message_logs={this.state.message_logs}
          nil={this.state.nil}
          onChangeUld={this.onChangeUld}
          checkHandledAs={this.checkHandledAs}
          uldFields={this.state.uldFields}
          handleUld={this.handleUld}
          deleteUld={this.handleDeleteUld}
          deleteAwb={this.handleDeleteAwb}
          add_uld={this.state.add_uld}
          add_awb={this.state.add_awb}
          onAddUld={this.onAddUld}
          onAddAwb={this.onAddAwb}
          onChangeAwb={this.onChangeAwb}
          awbFields={this.state.awbFields}
          handleAwb={this.handleAwb}
          onChangeNil={this.onChangeNil}
          handleHistory={this.handleHistory}
          handleClose={this.handleClose}
          anchorEl={this.state.anchorEl}
          handleFilter={this.handleFilter}
          handleOpen={this.handleOpen}
          onClose={this.onClose}
          modal={this.state.modal}
          modal_data={this.state.modal_data}
          productsList={this.state.productsList}
          uld_remarks={this.state.uld_remarks}
          awb_value={this.state.awb_value}
          manifestData={this.state.data}
          ffm={this.state.ffm}
          onChange={this.onChange}
          onRefresh={this.onRefresh}
          showReportModal={this.props.showReportModal}
          noScanAwbs={this.state.no_scan_awbs}
          is_empty={this.state.is_empty}
          nil_manifest={this.props.nil}
          handleUpload={this.props.handleUpload}
          loadingManifest={this.props.loadingManifest}
          onChangeNilManifest={this.props.onChangeNil}
          rowRefs={this.rowRefs}
          columnRef={this.columnRef}
          columnWidth={this.state.columnWidth}
          showRejectedMessage={this.props.showRejectedMessage}
          showNilMessage={this.props.showNilMessage}
          airlineLogo={this.props.airlineLogo}
          handleFullScreenToggle={this.handleFullScreenToggle}
          fullscreen={this.state.fullscreen}
          handleToggle={this.handleToggle}
          open={this.state.open}
          filter={this.state.filter}
          onChangeFilter={this.onChangeFilter}
          filterManifestData={this.filterManifestData}
          filteredManifestData={this.state.filteredManifestData}
          disableFlightFields={this.state.disableFlightFields}
          isNoOp={this.state.isNoOp}
          flightInfo={this.props.flight}
          clearSearch={this.clearSearch}
          handleConfirm={this.handleConfirm}
          fileInputRef={this.fileInputRef}
          can_edit={this.state.can_edit}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    ffm: state.ffm,
    flight: state.flightInfo
  };
};

const mapDispatchToProps = (dispatch) => {
  return { setDelete: (data) => dispatch(setDeleteAction(data)) };
};

export default connect(mapStateToProps, mapDispatchToProps)(ManifestContainer);
